import * as THREE from "three";
import { SNAPPABLE_LAYER } from "@designboticteam/workspace-3d";

class ParcelSnapLines {
	public readonly sceneObject = new THREE.Group();
	private readonly material = new THREE.LineBasicMaterial();

	/** */
	public setRings(rings: Array<Array<THREE.Vector3>>): void {
		this.clear();

		for (const ring of rings) {
			const line = new THREE.Line(new THREE.BufferGeometry().setFromPoints(ring), this.material);
			line.layers.enable(SNAPPABLE_LAYER);
			line.visible = false;
			line.frustumCulled = false;
			this.sceneObject.add(line);
		}
	}

	/** */
	public clear(): void {
		for (const child of [...this.sceneObject.children]) {
			this.sceneObject.remove(child);

			if (child instanceof THREE.Line) {
				child.geometry.dispose();
			}
		}
	}

	/** */
	public dispose(): void {
		this.clear();
		this.material.dispose();
		this.sceneObject.removeFromParent();
	}
}

export { ParcelSnapLines };
